export class MetaCategory {
  constructor(public id: number, public label: string) {}
}
